import * as React from "react";
const SvgFiRrGrinBeamSweat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grin-beam-sweat_svg__a)">
      <path
        fill="#062147"
        d="M6 12a1 1 0 0 1-1-1c0-1.892 1.232-4 3-4s3 2.108 3 4a1 1 0 1 1-2 0c0-1.054-.679-2-1-2s-1 .946-1 2a1 1 0 0 1-1 1m7-1a1 1 0 0 0 2 0c0-1.054.68-2 1-2s1 .946 1 2a1 1 0 0 0 2 0c-.248-5.285-5.753-5.282-6 0m7.5-4A2.5 2.5 0 0 0 23 4.5c.072-1.083-1.837-5.626-3.073-4.23A8.37 8.37 0 0 0 18 4.5 2.5 2.5 0 0 0 20.5 7m3.179 2.23a1 1 0 1 0-1.948.458 10 10 0 1 1-6.242-7.063 1 1 0 0 0 .7-1.874C8.571-2.229-.153 3.801 0 12.001a12 12 0 1 0 23.679-2.772M12 19a6.83 6.83 0 0 0 5.842-3.458 1 1 0 0 0-1.053-1.518c-1.534.578-3.15.908-4.789.976a15.4 15.4 0 0 1-4.8-.976 1 1 0 0 0-1.052 1.518A6.84 6.84 0 0 0 12 19"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grin-beam-sweat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrinBeamSweat;
